<div class="container">
  <div class="title">
    <h1 class="text-danger">Unauthorized.</h1>
    <h2 class="text-danger">An error occurred while authenticating your request.</h2>

  </div>
</div>
